import { render, staticRenderFns } from "./MarkIcon.vue?vue&type=template&id=07dc055e&"
import script from "./MarkIcon.vue?vue&type=script&lang=js&"
export * from "./MarkIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports